import React from 'react';
import { IRating } from '@/finsight/domain/vo/IRating';
import ITranch from '@/finsight/domain/vo/Tranch/ITranch';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const getCell = (tranche: ITranch, rating: IRating) => (
  tranche.ratings[rating.id]
    ? tranche.ratings[rating.id][0].abbreviation
    : '-'
);

export interface IRatingAgencyCellProps {
  tranche: ITranch,
  rating: IRating,
  rowIndex: number,
}

const RatingAgencyCell = ({
  rowIndex,
  tranche,
  rating,
}: IRatingAgencyCellProps) => (
  <BodyCell
    name="RatingAgencyCell"
    className={ alignStyles.alignCenter }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ () => getCell(tranche, rating) }
  />
);

export default RatingAgencyCell;
